import { shell, Title, Eyebrow, serif } from "../components/CommonComponents";

const Highlights = ({ course }) => {
  return (
    <section id="highlights" className="relative overflow-hidden bg-[#071A2F] py-20 text-white sm:py-24 lg:py-28">
      <img
        src={course.images.laboratory}
        alt="Applied learning environment"
        className="absolute inset-0 h-full w-full object-cover opacity-[0.11]"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#071A2F] via-[#071A2F]/95 to-[#8B1E3F]/40" />
      <div className={`${shell} relative`}>
        <Eyebrow dark>Learning experience</Eyebrow>
        <Title dark>Program Highlights</Title>
        <div className="mt-12 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
          {course.highlights.map(([title, text], i) => (
            <article
              key={title}
              className="group min-h-[280px] rounded-[4px_38px_4px_4px] border-l-4 border-l-[#D5AD57] border-y border-r border-white/15 bg-[#071A2F]/50 p-7 backdrop-blur-sm transition hover:-translate-y-1 hover:border-[#D5AD57]"
            >
              <span className={`${serif} text-5xl text-[#D5AD57]`}>
                0{i + 1}
              </span>
              <h3 className="mt-8 text-xl font-semibold">{title}</h3>
              <p className="mt-4 text-sm leading-7 text-white/60">{text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Highlights;
